import angular from 'angular';

import _css from './od-photo-tooltip.less';

module.exports = angular.module('common.directives.od-photo-tooltip', [])
.directive('odPhotoTooltip', () => {
  return {
    restrict: 'EA',
    scope: {
      photo: '@'
    },
    templateUrl: '/templates/common/directives/od-photo-tooltip.html'
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-photo-tooltip.js
 **/